import ICONS from '@/shared/entities/constants/icons';
import React, { Dispatch, SetStateAction, useEffect, useRef } from 'react';
import IconBox from '@/components/iconBox';
import { Button, Dialog, Text } from 'vkit/lib/components';
import { Grid } from 'vkit/lib/context';

interface DialogConfirmDeleteHealthDataConfigProps {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  confirm: (confirmation: boolean) => void;
}

export const DialogConfirmDeleteHealthDataConfig: React.FC<
  DialogConfirmDeleteHealthDataConfigProps
> = ({ open, setOpen, confirm }) => {
  const useRefDialog = useRef({ open: () => {}, dismiss: () => {} });

  useEffect(() => {
    open ? useRefDialog.current.open() : useRefDialog.current.dismiss();
  }, [open]);

  return (
    <Dialog
      shadow
      outlined
      rounded
      instanceEmitter={useRefDialog.current}
      onClose={() => setOpen(false)}
      elevation={2}
      size='larger'
      body={
        <Grid column padding={30}>
          <Grid margin='0 0 32px' alignContent='center' stretch>
            <IconBox icon={ICONS.ALERT} size={70} circle color='danger' />
          </Grid>

          <Grid margin='0 0 16px' alignContent='center' stretch>
            <Text
              value='Deseja desabilitar as empresas selecionadas?'
              title
              size='medium'
              color='colorDefault'
            />
          </Grid>

          <Grid margin='0 0 24px' alignContent='center' stretch>
            <Text
              value='Ao desabilitar, os indicadores de plano de saúde deixarão de estar disponíveis para essas empresas'
              size='medium'
              textAlign='center'
            />
          </Grid>

          <div style={{ width: 408, margin: 'auto' }}>
            <Grid gap={16}>
              <Button
                size='larger'
                testId='confirm_no'
                onClick={() => confirm(false)}
                label='Cancelar'
                solo
                outlined
                full
              />

              <Button
                size='larger'
                testId='confirm_yes'
                onClick={() => confirm(true)}
                label='Desativar'
                outlined
                full
              />
            </Grid>
          </div>
        </Grid>
      }
    />
  );
};
